<template>
  <div class="home">
    <div class="header">
      <img class="header-info" src="@/assets/info.png" @click="$refs.info.openModal()">
        <h1 class="header-title">Wordle Argento</h1>
        <div class="header-right">
      <img src="@/assets/statistics.png" @click="$refs.statistics.openModal()">
      <img src="@/assets/settings.png" @click="$refs.settings.openModal()">
        </div>
    </div>

    <WordleGame/>

    <modal ref="info">
      <template v-slot:header>
        <h2>CÓMO JUGAR</h2>
      </template>

      <template v-slot:body>
        <div class="info__text">
          <p>
            Adivina la palabra oculta en seis intentos.
            <br>
            Cada intento debe ser una palabra válida de 5 letras.
            <br>
            Después de cada intento el color de las letras cambiará para mostrar qué tan cerca estás de acertar la palabra.
            <br>
            Las palabras aceptadas no necesariamente deberán ser argentinas.
            <br>
            Las palabras argentinas incluyen celebridades, personajes, comidas, lunfardo, etc.
          </p>
          <hr>
          <p><strong>EJEMPLOS</strong></p>
          <div class="row">
            <span class="letter green-overlay">B</span>
            <span class="letter">O</span>
            <span class="letter">N</span>
            <span class="letter">D</span>
            <span class="letter">I</span>
          </div>
            <p>
              La letra <strong>B</strong> está en la palabra y en la posición correcta.
            </p>
          <div class="row">
            <span class="letter">Q</span>
            <span class="letter yellow-overlay">U</span>
            <span class="letter">I</span>
            <span class="letter">N</span>
            <span class="letter">O</span>
          </div>
            <p>
              La letra <strong>U</strong> está en la palabra pero en la posición incorrecta.
            </p>
          <div class="row">
            <span class="letter">P</span>
            <span class="letter">A</span>
            <span class="letter grey-overlay">C</span>
            <span class="letter">H</span>
            <span class="letter">U</span>
          </div>
            <p>
              La letra <strong>C</strong> no está en la palabra.
            </p>
        </div>
      </template>
    </modal>

    <modal ref="statistics">
      <template v-slot:header>
        <h3>WORDLE ARGENTO #{{this.wordleNumber}}</h3>
      </template>

      <template v-slot:body>
          <p v-if="this.gameOver == 'true'" v-html='this.lastEmojiSquares'></p>
          <p v-if="this.gameOver == 'true'">La palabra era: <span style="text-transform: uppercase">{{this.secretWord}}</span></p>

          <h3>ESTADÍSTICAS</h3>

          <div class="stats__container">
            <div class="jugadas">
              <span v-if="this.gamesPlayed == null" style="font-size: 30px">0</span>
              <span v-else style="font-size: 30px">{{this.gamesPlayed}}</span>
              <span>jugadas</span>
            </div>
            <div class="victorias">
              <span v-if="this.percentage == null" style="font-size: 30px">0%</span>
              <span v-else style="font-size: 30px">{{this.percentage}}%</span>
              <span>victorias</span>
            </div>

            <div class="nextWord">
              <strong>Siguiente palabra</strong>
              <div>
                {{this.hours}}:{{this.minutes}}:{{this.seconds}}
              </div>
            </div>
            <div v-if="this.gameOver == 'true'" class="shareGuess" @click="copyToClipboard()">Compartir resultado</div>
          </div>
      </template>
    </modal>

    <modal ref="settings">
      <template v-slot:header>
        <h2>AJUSTES</h2>
      </template>

      <template v-slot:body>
        <div  class="info__text">
          <div class="dSection">
          Modo para Daltónicos
          <label class="switch">
            <input type="checkbox" 
              v-model="colorblindCheckBox" 
              @change="toggleColorblind">
            <span class="slider round"></span>
          </label>
          </div>
          <hr>
          <p>
            Creado por <a href="https://www.instagram.com/camipalo/">Camila</a>. Inspirado en <a href="https://www.nytimes.com/games/wordle/index.html">Wordle</a>.
          </p>
          <p>
            Podes <a href="https://forms.gle/ZNK75fxjMEYCC5KWA">sugerir palabras acá</a>.
          </p>
          <hr>
          <p>
            Si te gustó el juego y queres ayudarme podes hacerlo en <a href="https://cafecito.app/camilitis">CafecitoApp</a> ó <a href="https://ko-fi.com/camilitis">Ko-Fi</a>.
          </p>
        </div>
      </template>
    </modal>

  </div>
</template>

<script>
import WordleGame from '@/components/WordleGame.vue'
import Modal from '@/components/Modal.vue'

const epochMs = new Date('February 26, 2022 00:00:00').valueOf()
const now = Date.now()
const msInDay = 86400000
const index = Math.floor((now - epochMs) / msInDay)
const nextday = (index + 1) * msInDay + epochMs

function prependZero(number) {
  if (number < 9){
    return "0" + number
  }else{
    return number
  }
}

export default {
  name: 'Home',
  components: {
    WordleGame,
    Modal
  },
  data(){
    return{
      hours: true,
      minutes: true,
      seconds: true,

      colorblindCheckBox: false,
      localColorblindCheckBox: window.localStorage.getItem('colorblindCheckBox'),

      lastEmojiSquares: null,

      //CSS color
      colorGreen: '#6aaa64',
      colorYellow: '#c9b458',
      colorGrey: '#3a3a3c',
      }
    },
  computed:{
    gamesPlayed(){
      return this.$store.state.gamesPlayed
    },
    percentage(){
      return this.$store.state.percentage
    },
    secretWord(){
      return this.$store.state.secretWord
    },
    gameOver(){
      return this.$store.state.gameOver
    },
    wordleNumber(){
      return this.$store.state.solutionIndex
    },
    wordsElements(){
      return this.$store.state.wordsElements
    }
  },

  methods:{
    timeLeft(){
      setInterval(() => {
      const now = new Date().getTime()
      var timeleft = nextday - now

      this.hours = prependZero(Math.floor((timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)))
      this.minutes = prependZero(Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60)))
      this.seconds = prependZero(Math.floor((timeleft % (1000 * 60)) / 1000))

      if (this.hours == '00' && this.minutes == '00' && this.seconds == '00') {
        location.reload()
        window.localStorage.removeItem('lastWord')
      }
      }, 1000)
    },

    setEmojiSquares(){
      var emojiSquares = this.wordsElements.join('').split(/(.{5})/).filter(e => e).join('<br>')

      const greenS = /a/g
      const yellowS = /c/g
      const greyS = /d/g

      emojiSquares = emojiSquares.replace(greenS, '🟩')
      emojiSquares = emojiSquares.replace(yellowS, '🟨')
      emojiSquares = emojiSquares.replace(greyS, '⬛')

      this.lastEmojiSquares = emojiSquares
    },

    copyToClipboard(){
      const linebreak = '<br>'
      var emojiSquares = this.lastEmojiSquares

      var copyEmojiSquares = emojiSquares.replace(new RegExp(linebreak, "g"), '\n')

      navigator.clipboard.writeText('Wordle Argento #' + this.wordleNumber + '\n' + '\n' + copyEmojiSquares + '\n' + '\n' + 'https://wordleargento.vercel.app')

      this.$store.commit('copiedToClipboard')
    },

    reloadEmojiSquares(){
      var emojiSquares = JSON.parse(window.localStorage.getItem('oldEmojiSquares'))
      emojiSquares = emojiSquares.join('').split(/(.{5})/).filter(e => e).join('<br>')

      const greenS = /a/g
      const yellowS = /c/g
      const greyS = /d/g

      emojiSquares = emojiSquares.replace(greenS, '🟩')
      emojiSquares = emojiSquares.replace(yellowS, '🟨')
      emojiSquares = emojiSquares.replace(greyS, '⬛')

      this.lastEmojiSquares = emojiSquares
    },

    normalColors(){
      this.colorGreen = '#6aaa64'
      this.colorYellow = '#c9b458'
    },
    colorblindColors(){
      this.colorGreen = '#F5793A'
      this.colorYellow = '#85C0F9'
    },

    toggleColorblind(){
      if(this.colorblindCheckBox == true){
        window.localStorage.setItem('colorblindCheckBox', 'true')

        this.colorblindColors()
      }else if(this.colorblindCheckBox == false){
        window.localStorage.setItem('colorblindCheckBox', 'false')

        this.normalColors()
      }
    },

    checkColorblind(){
    if(this.localColorblindCheckBox === 'true'){
      this.colorblindCheckBox = true

      this.colorblindColors()
    }else if(this.localColorblindCheckBox === 'false'){
      this.colorblindCheckBox = false

      this.normalColors()
    }
    }
  },

  mounted(){
    this.timeLeft()
    this.setEmojiSquares()

    this.checkColorblind()

    if(window.localStorage.getItem('gameOver') == 'true' || window.localStorage.getItem('gameOver')){
      this.reloadEmojiSquares()
      this.$refs.statistics.openModal()
    }
  }
}
</script> 
<style lang="scss">
@media (prefers-color-scheme: light){
  :root{
    --background-color: #f5f5f5;
    --text-color: #121213;
    }
}
@media (prefers-color-scheme: dark){
  :root{
    --background-color: #121213;
    --text-color: #f5f5f5;
    }
}

.green-overlay {
  background-color: v-bind(colorGreen) !important;
}
.yellow-overlay {
  background-color: v-bind(colorYellow);
}
.grey-overlay {
  background-color: v-bind(colorGrey);
}

body{
  background-color: var(--background-color);
  color: var(--text-color);
  margin: 0;
}

#app {
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  padding: 0;
  margin: 0 auto;
  width: 98vw;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.header{
  text-transform: uppercase;
  font-weight: bold;
  border-bottom: 1px solid #555;
  align-items: center;
  display: grid; 
  grid-template-columns: 0.17fr 1fr 0.17fr;
  grid-template-areas: 
    "header-info header-title header-right"; 
    h1{
      font-size: 30px;
    }
}
img{
  height: 20px;
  cursor: pointer;
}

.header-info {
  margin: auto;
  grid-area: header-info;
}
.header-title { grid-area: header-title; }
.header-right{
  display: flex;
  justify-content: space-between;
  grid-area: header-right; 
}

.info__text{
  text-align: left;
  padding: 0 20px;
  box-sizing: border-box;
  a{
    color: #737373;
  }
}

.stats__container{
  display: grid;
  grid-template-areas:
    "jugadas victorias"
    "nextWord shareGuess";
  text-align: center;
  align-items: center;
  text-transform: uppercase;
  grid-gap: 50px;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
}
.jugadas{grid-area: jugadas}
.victorias{grid-area: victorias}
.nextWord{grid-area: nextWord}
.shareGuess{
  grid-area: shareGuess;
  padding: 10px;
  box-sizing: content-box;
  background-color: #6aaa64;
  border-radius: 5px;
  cursor: pointer;
  font-weight: 600;
}
.distribucion{grid-area: distribution}

.nextWord, .shareGuess, .victorias, .jugadas{
  display: flex;
  flex-direction: column;
}

.dSection{
  display:flex;
  justify-content: space-between;
}

//Settings
.switch {
  position: relative;
  display: inline-block;
  width: 42px;
  height: 26px;
}
.switch input { 
  opacity: 0;
  width: 0;
  height: 0;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}
.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}
input:checked + .slider {
  background-color: #2196F3;
}
input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}
input:checked + .slider:before {
  -webkit-transform: translateX(16px);
  -ms-transform: translateX(16px);
  transform: translateX(16px);
}
/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}

@media screen and (max-width: 500px){
.stats__container{
  grid-template-areas:
    "jugadas victorias"
    "nextWord nextWord"
    "shareGuess shareGuess";
}
}
</style>